export const GET_USER = 'auth/getUser'
export const LOGIN = 'auth/login'
export const REGISTER = 'auth/register'
export const REFRESH_TOKEN = 'auth/refreshToken'
export const LOGOUT = 'auth/logout'
export const SET_IS_EXPIRED = 'auth/setIsExpired'
